import {billing, cvv_types, mladi_voznik} from "./proto/compiled";

export abstract class CvvStrings {
    static vozilo: { [k: number]: string } = {
        [cvv_types.Vozilo.svoje]: 'SVOJE',
        [cvv_types.Vozilo.najeto]: 'NAJETO',
        [cvv_types.Vozilo.najeto_prijatelj]: 'NAJETO S PRIJATELJEM',
        [cvv_types.Vozilo.najeto_druga_oseba]: 'NAJETO Z DRUGO OSEBO',
    }

    static voziloCategory: { [k: number]: string } = {
        [mladi_voznik.NajemVozilaCategory.a1]: 'A',
        [mladi_voznik.NajemVozilaCategory.a2]: 'A2',
    }

    static napotilo: { [k: number]: string } = {
        [mladi_voznik.KazenskeTockeNapotilo.sodisce]: 'SODIŠČE',
        [mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled]: 'ZDRAVSTVENI PREGLED',
        [mladi_voznik.KazenskeTockeNapotilo.prostovoljno]: 'PROSTOVOLJNO',
    }

    static placilo: { [k: number]: string } = {
        [billing.PaymentStatus.no_proforma_invoice]: 'POTRDITEV POSLANA',
        [billing.PaymentStatus.proforma_invoice]: 'PREDRAČUN POSLAN',
        [billing.PaymentStatus.amount_mismatch]: 'NAPAKA PLAČILA',
        [billing.PaymentStatus.paid]: 'PLAČILO OK',
        [billing.PaymentStatus.gratis]: 'BREZPLAČNO'
    }


    static prijav(count: number) {
        if (count === 0) return 'prijav';
        if (count === 1) return 'prijava';
        if (count === 2) return 'prijavi';
        if (count >= 2 && count <= 4) return 'prijave';
        return 'prijav';
    }

    static prostihMest(count: number | null | undefined) {
        if (count === 0) return 'prostih mest';
        if (count === 1) return 'prosto mesto';
        if (count === 2) return 'prosti mesti';
        if (count === 3 || count === 4) return 'prosta mesta';
        return 'prostih mest';
    }
}

export const CvvRoutes = {
    admin: {
        razpisaniTecaji: '/admin/',
        razpisaniTecaj: (id?: string) => '/admin/razpisani-tecaj/' + (id ? (id + '/') : ''),
        prijavljeneOsebe: '/admin/prijavljene-osebe/',
    },

    izjava_o_odgovornosti: '/izjava-o-odgovornosti',
    formSummary: (sessionId?: string) => `/summary/${sessionId}/`,
    editForm: (sessionId?: string) => `/resume/${sessionId}/`,
    novaPrijava: (tip: string, tecaj: string) => `/${tip}/${tecaj}/`,
    prijavaNaTecaj: (tip: string, tecaj: string, lid?: string, ltd?: string) => {
        const base = `https://www.amzs.si/cvv/prijava-na-tecaj/${tip}/${tecaj}/`;
        if (lid && ltd) {
            return `${base}?lid=${lid}&ltd=${ltd}`;
        }
        return base;
    },
};

export const CvvPaymentType = {
    [billing.PaymentType.gotovina]: 'GOTOVINA',
    [billing.PaymentType.kreditna]: 'KREDITNA',
    [billing.PaymentType.darilni_bon]: 'DARILNA KARTICA',
    [billing.PaymentType.predracun]: 'PLAČILO PO PREDRAČUNU',
}